import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import numeral from 'numeral'
import Header from 'components/CameraModelSelector/Header'
import Favorite from 'components/CameraModelSelector/CameraDetailsContainer/CameraDetails/Favorite'
import LimitTable from './LimitTable'

const ModelDetails = ({ selectedModel, usages, changeModelAction, permalink, modelCount, expansionSelector, addingExpansion, classes }) =>
  <div className={expansionSelector ? classes.expansionContainer : classes.container}>
    <Header title='Info' />
    <div className={classes.list}>
      { selectedModel &&
        <div className={classes.details}>
          { !permalink && !expansionSelector && <Favorite id={selectedModel.id} controllerModel /> }
          { selectedModel.image_url && <img src={selectedModel.image_url} /> }
          <h4>{selectedModel.manufacturer}</h4>
          <h4>{selectedModel.model}</h4>
          { expansionSelector
            ? <span>
                <strong>Connection Type: </strong>
                {selectedModel.connection}
              </span>
            : <span>
                <strong>Supports Expansion Controllers: </strong>
                {selectedModel.allows_expansion ? 'Yes' : 'No'}
              </span>
          }
          <strong style={{ paddingTop: '.5rem' }}>Connection Limits:</strong>
          <LimitTable
            selectedModel={selectedModel}
            addingExpansion={addingExpansion}
            usages={usages}
            key={selectedModel ? selectedModel.id : 'none'}
          />
          <button
            className={classes.selectModelButton}
            onClick={event => changeModelAction(selectedModel, event.target)}
          >
            <FontAwesomeIcon icon={['far', 'microchip']} />
            { addingExpansion ? 'Add This Expansion Controller' : 'Select This Controller' }
          </button>
        </div>
      }
      { !selectedModel && modelCount > 0 &&
        <div className={classes.modelCountDisplay}>
          Choose from
          <strong>{numeral(modelCount).format('0,0')} models</strong>
          <hr className={classes.break} />
          <a
            href={`${IPVM_URL}/contact?subject=${expansionSelector ? 'Expansion' : 'Door'} Controller Model To Add&message=Please add`}
            target='_blank'
            className={classes.missingModelButton}
          >
            Want us to add a missing model?
            <br />
            Let us know
          </a>
        </div>
      }
    </div>
  </div>

export default injectSheet(style)(ModelDetails)



// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/ModelDetails/index.js